import { salesIndigoSurfaceCardClass } from "@/components/common/surfaceClasses";
import { isToday, parseLocalCalendarDay } from "@/lib/service/calendarLocalWeek";
import type { ServiceCalendarDayRollup } from "@/lib/service/calendarLocalWeek";

type Props = {
  weekKeys: string[];
  rollups: ServiceCalendarDayRollup[];
  selectedDay: string | null;
  onSelectDay: (date: string) => void;
};

function dayHeading(date: string): string {
  const d = parseLocalCalendarDay(date);
  if (!d) return date;
  return d.toLocaleDateString(undefined, { weekday: "short", month: "numeric", day: "numeric" });
}

export function ServiceCalendarWeekGrid({ weekKeys, rollups, selectedDay, onSelectDay }: Props) {
  const byDate = new Map(rollups.map((r) => [r.date, r]));

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-2">
      {weekKeys.map((date) => {
        const rollup = byDate.get(date);
        const selected = selectedDay === date;
        const today = isToday(date);
        return (
          <button
            key={date}
            type="button"
            onClick={() => onSelectDay(date)}
            className={`${salesIndigoSurfaceCardClass} text-left p-2 transition-colors ${
              selected
                ? "ring-2 ring-indigo-500 border-indigo-300 dark:ring-indigo-400"
                : "hover:bg-indigo-50/80 dark:hover:bg-indigo-950/40"
            }`}
          >
            <div className="text-[11px] font-semibold text-indigo-900 dark:text-indigo-200">
              {dayHeading(date)}
              {today ? (
                <span className="ml-1 text-[10px] font-normal text-indigo-600 dark:text-indigo-300">
                  (today)
                </span>
              ) : null}
            </div>
            <div className="mt-1 space-y-0.5 text-[10px] text-gray-700 dark:text-zinc-300">
              <div>Scheduled: {rollup?.scheduled ?? 0}</div>
              <div>In progress: {rollup?.in_progress ?? 0}</div>
              <div>Complete: {rollup?.complete ?? 0}</div>
            </div>
            <div className="mt-1 text-[10px] text-gray-500 dark:text-zinc-500">
              {(rollup?.events.length ?? 0) === 0
                ? "No events"
                : `${rollup!.events.length} event(s)`}
            </div>
          </button>
        );
      })}
    </div>
  );
}
